import { FincasPlataformaService } from "../../../shared/generated/grpc/plataforma_terceros_fincas_pb";
import { GuardarLotesPayload } from "../../../shared/services/api/payload/terceros/GuardarLotesPayload";
import { grpcCall, grpcClient } from "../../../shared/services/grpc/grpcCall";

/** Carga de lotes desde un KML/KMZ/ZIP ya subido (`FincasPlataformaService.GuardarLotes`, gRPC). */
export class GuardarLotesService {
  /** Reemplaza los lotes de la finca (reconcilia por nombre); requiere AOI cargado. */
  static async guardar(payload: GuardarLotesPayload): Promise<void> {
    await grpcCall(() => grpcClient(FincasPlataformaService).guardarLotes({ fincaId: payload.fincaId, blobUrl: payload.uriKml }));
  }
}
